<template>
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.PRIMARY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >

        <div class="is-full-width is-full-height">
            <img v-if="!isAfter20260301"
                 :src="buildImgUrl('jhsfree_graduation_1.png')"
                 alt="中3の2/28でプリ画が無料で全部もらえる期間が終了します 3月からは無料で1枚保存できます！※これまでのプリは消えないよ！"
                 data-jest="before-img-1">
            <img v-else
                 :src="buildImgUrl('jhsfree_graduation_1_after_20260301.png')"
                 alt="中3の2/28でプリ画が無料で全部もらえる期間が終了します 3月からは無料で1枚保存できます！※これまでのプリは消えないよ！"
                 data-jest="after_20260301-img-1">
            <img :src="buildImgUrl('jhsfree_graduation_2.png')" alt="3月からも全部保存したい方へ プレミアム会員になれば、3月からも大事な思い出をプリで全部残せるよ！※プレミアム会員になるのは3月からがおすすめ！" data-jest="before-img-2">
            <img :src="buildImgUrl('jhsfree_graduation_3.png')" alt="中3のみんなはどうやってプレミアム会員になっているの？">
            <img :src="buildImgUrl('jhsfree_graduation_4.png')" alt="中3のみんなはどうやってプレミアム会員になっているの？(漫画)">

            <img v-if="isAppli" :src="buildImgUrl('jhsfree_graduation_5.png')" alt="プレミアム会員について " data-jest="price-description-img">
            <img v-else :src="buildImgUrl('jhsfree_graduation_5_web.png')" alt="プレミアム会員について" data-jest="price-description-img">

            <img :src="buildImgUrl('jhsfree_graduation_6.png')" alt="プレミアム会員ならプリが全部もらえる！プリ機でらくがきしあプリをらくがきする前のプリがもらえる！">

            <img v-if="isAppli" :src="buildImgUrl('jhsfree_graduation_7.png')" alt="どんな支払い方法があるの？ 支払い方法の例: PayPay クレジットカード キャリア決済">
            <img v-else :src="buildImgUrl('jhsfree_graduation_7_web.png')" alt="どんな支払い方法があるの？ 支払い方法の例: クレジットカード キャリア決済 ※アプリ版の場合、PayPayでお支払いできます">

            <img :src="buildImgUrl('jhsfree_graduation_8.png')" alt="今までは無料でプレミアム会員の機能を使っていたよ！高校生になってもたくさん思い出を残そうね！">
        </div>
        <!--フロートボタン-->
        <div v-if="!isAppli" class="c-jhs-free-graduation-animation_button show-button" :class="isScrollFull ? 'is-none' : ''">
            <jhs-free-graduation-btn-float-bottom
                :is-active="!hasJhsFreeVoucher"
                data-jest="lp-btn-float-bottom"
            />
        </div>
    </base-layout>
</template>
<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import * as urlUtil from "../../../util/UrlUtil";
import {getScrollEvent} from "../../../util/Ga4EventUtil.js";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import {mapGetters} from "vuex";
import JhsFreeGraduationBtnFloatBottom from "../../molecules/JhsFreeGraduationBtnFloatBottom.vue";

export default {
    name: "JhsFreeGraduation",
    components: {BaseLayout, JhsFreeGraduationBtnFloatBottom},
    props: {
        /**
         * title
         */
        title: {
            type: String,
            required: true
        },
        /**
         * description
         */
        description: {
            type: String,
            required: true
        },
        hasJhsFreeVoucher: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            isScrollFull: false,
        }
    },
    computed: {
        ...mapGetters('AccountStoreV2', [
            'accountStatus',
            'isAppli'
        ]),
        isAfter20260301() {
            return this.accountStatus.timeTripDate.isAfterTime("2026-03-01T00:00:00")
        },
    },
    methods: {
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/graduation/2025/' + imgName)
        },
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        /**
         * アニメーション
         * @param target
         * @param options
         */
        onIntersect(target, options = {}) {
            const observer = new IntersectionObserver(this.addShowClass, options)
            // 監視したい要素をobserveする。
            observer.observe(target)
        },
        addShowClass(entries) {
            for (const e of entries) {
                // isInterseting判定で要素が交差したらclassを付与する
                if (e.isIntersecting) {
                    e.target.classList.add("show-section")
                    e.target.classList.add("show-button")
                }
            }
        },
        /**
         * スクロール
         */
        onScroll() {
            const allHeight = Math.max(
                document.body.scrollHeight, document.documentElement.scrollHeight,
                document.body.offsetHeight, document.documentElement.offsetHeight,
                document.body.clientHeight, document.documentElement.clientHeight
            );
            const mostBottom = allHeight - window.innerHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            // ブラウザによってスクロール値の反応が変わるようなので
            // 最下部ではなく下から100pxあたりでボタン非表示にするよう微調整している
            this.isScrollFull = (scrollTop + 100) >= mostBottom;
        },

    },
    mounted() {
        getScrollEvent();
        this.setTitleAndDesc();
        window.addEventListener('scroll', this.onScroll, {
            capture: true
        })
    },
}
</script>
<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use '../../../../scss/v2/base/_utility';

.c-jhs-free-graduation {
    &-animation {
        opacity: variables.$opacity-0;
        transform: translateY(40px);
        transition: opacity 0.2s, transform 0.8s;

        &.show-section {
            opacity: variables.$opacity-100;
            transform: translateY(0);
        }

        &_button {
            .button {
                opacity: variables.$opacity-0;
                transform: translateY(40px);
                transition: opacity 0s, transform 0.8s;
            }

            &.show-button {
                width: 100%;
                opacity: variables.$opacity-100;
                transform: translateY(0);
                position: fixed;
                bottom: 0;
                left: 0;

            }
        }
    }
}

.is-none {
    display: none;
}
</style>
